import useMyResourceParams from '@/hooks/refinedev/useMyResourceParams';
import {Toolbar} from './workflow/toolbar/workflow-toolbar';
import {ReactFlowProvider} from '@xyflow/react';
import ProjectWorkflow from './workflow/workflow';
import Loader from '@/components/Loader';
import {useLoadWorkflow} from './workflow/hooks/useLoadWorkflow';
import {BreadcrumbsType, useSetCustomBreadcrumb} from '@/hooks/useBreadcrumbs';
import {useMemo} from 'react';

const ProjectEditWorkflow = () => {
  const m = useMyResourceParams();
  const {loadWorkflow} = useLoadWorkflow(m.id);

  const breadcrumbs: BreadcrumbsType[] = useMemo(() => {
    const data = loadWorkflow.data;
    if (!data) return [];
    return [
      {path: `/projects/${m.id}/show`, label: data.name},
      {path: `/projects/${m.id}/editwf`, label: 'Lưu đồ'},
    ];
  }, [loadWorkflow.data]);
  useSetCustomBreadcrumb(breadcrumbs);

  // returns
  if (!m?.resource?.name || !m?.id) return <p>Lỗi định danh tài nguyên: {JSON.stringify(m)}</p>;

  if (loadWorkflow.isLoading) return <Loader />;

  return (
    <ReactFlowProvider>
      <div className="flex flex-col h-full w-full">
        <Toolbar resource="projects" id={String(m.id)} />
        <ProjectWorkflow className="h-full w-full" />
      </div>
    </ReactFlowProvider>
  );
};

export default ProjectEditWorkflow;
